import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import ReactTable from 'react-table';
import "react-table/react-table.css";

class Chart extends Component {
  state = { active: true, dataPrecise: {}, dataAtLeast: {}, data: [] }

  componentWillMount () {
    const { dataPrecise, dataAtLeast } = this.props;

    this.setState({ dataPrecise }, () => {
      // console.log("((dataPrecise)):", dataPrecise);
    });

    this.setState({ dataAtLeast }, () => {
      // console.log("((dataAtLeast)):", dataAtLeast);
    });
    this.calculateChart
  }

  calculateChart = () => {
    const { dataPrecise, dataAtLeast } = this.state;
    let data = [];

    dataPrecise.map((row, index) => {
      data.push(
        {"exposures": row.name,
        "preciseLower": ((row.range[0]) * 100).toFixed(1) + '%',
        "preciseUpper": ((row.range[1]) * 100).toFixed(1) + '%',
        "atLeastLower": ((dataAtLeast[index].range[0]) * 100).toFixed(1) + '%',
        "atLeastUpper": ((dataAtLeast[index].range[1]) * 100).toFixed(1) + '%'
      });
    });
    return(data);
  }

  render() {
    let chartData = this.calculateChart();
    console.log("Chart Data: ", chartData);

    return(
      <Container>
        <h2>Chart</h2>

        <ReactTable
          data={chartData}
          columns={[
            { Header: "Impressions", accessor: "exposures"},
            { Header: "Precisely", columns: [
              { Header: "Lower", accessor: "preciseLower"},
              { Header: "Upper", accessor: "preciseUpper"}
            ]},
            { Header: "At Least", columns: [
              { Header: "Lower", accessor: "atLeastLower"},
              { Header: "Upper",accessor: "atLeastUpper"}
            ]}
          ]}
        />
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dataPrecise: state.dataPrecise,
    dataAtLeast: state.dataAtLeast,
  }
}

export default connect(mapStateToProps)(Chart);



// WEBPACK FOOTER //
// ./src/components/Chart.js